import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Title, LoadingCard, RequiredAsterisk } from '../../Shared';
import { locationActions } from '../../_actions';
import { LocationEquipment } from './';
import { AdminHeader } from '../';
import { states, stateMap } from './states';

class LocationEdit extends Component {
  state = {};
  componentDidMount = () => {
    const { path } = this.props.match.params;
    if (path) {
      this.props.getSingle(path);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { single } = this.props;
    this.props.update({ ...single, ...this.state });
  };

  render() {
    const { single, loading, updating } = this.props;
    const { path } = this.props.match.params;
    const isShort = states.includes(single && single.state);

    const defaultState = isShort
      ? single.state
      : stateMap[single && single.state];
    return (
      <Fragment>
        {loading && (
          <Row>
            <LoadingCard />
          </Row>
        )}
        {!loading && single && (
          <Fragment>
            <Title text={`Editing ${single.name}`} />
            <AdminHeader goBack title={`Editing: ${single.name}`} />
            <Container className="mt-4">
              <Row>
                <Col>
                  <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                      <Label for="name">Name</Label>
                      <Input
                        id="name"
                        name="name"
                        onChange={this.handleChange}
                        defaultValue={single.name}
                      />
                      <small className="form-text text-muted">
                        Names must be unique amongst Park Warrior locations
                      </small>
                    </FormGroup>
                    <Row>
                      <Col xs="3">
                        <Label for="streetNumber">Street No.</Label>
                        <Input
                          name="streetNumber"
                          type="number"
                          value={this.state.streetNumber}
                          defaultValue={single.streetNumber}
                          onChange={this.handleChange}
                        />
                      </Col>
                      <Col>
                        <Label for="streetAddress">
                          Address <RequiredAsterisk />
                        </Label>
                        <Input
                          name="streetAddress"
                          defaultValue={single.streetAddress}
                          value={this.state.streetAddress}
                          required
                          onChange={this.handleChange}
                        />
                      </Col>
                    </Row>
                    <Row className="pt-2">
                      <Col>
                        <Label for="city">
                          City/Suburb <RequiredAsterisk />
                        </Label>
                        <Input
                          name="city"
                          defaultValue={single.city}
                          required
                          value={this.state.city}
                          onChange={this.handleChange}
                        />
                      </Col>
                      <Col xs="3">
                        <Label for="state">
                          State <RequiredAsterisk />
                        </Label>
                        <Input
                          type="select"
                          name="state"
                          value={this.state.state}
                          defaultValue={defaultState}
                          required
                          onChange={this.handleChange}
                        >
                          <option>Please Select</option>
                          {states.map((state) => {
                            return <option key={state}>{state}</option>;
                          })}
                        </Input>
                      </Col>
                    </Row>
                    <FormGroup className="pt-4">
                      {updating ? (
                        <Button color="primary">
                          <FontAwesomeIcon icon="spinner" spin /> Saving
                        </Button>
                      ) : (
                        <Button color="primary">Save Changes</Button>
                      )}
                    </FormGroup>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Fragment>
        )}

        {single && <LocationEquipment path={path} locationId={single.id} />}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { single, loading, updating } = state.location;
  return { single, loading, updating };
}

const mapDispatchToProps = {
  getSingle: locationActions.getSingle,
  update: locationActions.update,
};

const connectedLocEdit = connect(
  mapStateToProps,
  mapDispatchToProps,
)(LocationEdit);
export { connectedLocEdit as LocationEdit };
